import { API, CountryCode } from '~/types'

/**
 * Used to keep a sorted list of countries and names for the country selector
 */
export const countryList = [
	{ name: 'Norway', iso_code: CountryCode.NO },
	{ name: 'Canada', iso_code: CountryCode.CA },
	{ name: 'United Kingdom', iso_code: CountryCode.GB },
	{ name: 'United States', iso_code: CountryCode.US },
	{ name: 'Switzerland', iso_code: CountryCode.CH },
	{ name: 'Austria', iso_code: CountryCode.AT },
	{ name: 'Belgium', iso_code: CountryCode.BE },
	{ name: 'Bulgaria', iso_code: CountryCode.BG },
	{ name: 'Croatia', iso_code: CountryCode.HR },
	{ name: 'Cyprus', iso_code: CountryCode.CY },
	{ name: 'Czechia', iso_code: CountryCode.CZ },
	{ name: 'Denmark', iso_code: CountryCode.DK },
	{ name: 'Estonia', iso_code: CountryCode.EE },
	{ name: 'Finland', iso_code: CountryCode.FI },
	{ name: 'France', iso_code: CountryCode.FR },
	{ name: 'Germany', iso_code: CountryCode.DE },
	{ name: 'Greece', iso_code: CountryCode.GR },
	{ name: 'Hungary', iso_code: CountryCode.HU },
	{ name: 'Ireland', iso_code: CountryCode.IE },
	{ name: 'Italy', iso_code: CountryCode.IT },
	{ name: 'Latvia', iso_code: CountryCode.LV },
	{ name: 'Lithuania', iso_code: CountryCode.LT },
	{ name: 'Luxembourg', iso_code: CountryCode.LU },
	{ name: 'Malta', iso_code: CountryCode.MT },
	{ name: 'Netherlands', iso_code: CountryCode.NL },
	{ name: 'Poland', iso_code: CountryCode.PL },
	{ name: 'Portugal', iso_code: CountryCode.PT },
	{ name: 'Romania', iso_code: CountryCode.RO },
	{ name: 'Slovakia', iso_code: CountryCode.SK },
	{ name: 'Slovenia', iso_code: CountryCode.SI },
	{ name: 'Spain', iso_code: CountryCode.ES },
	{ name: 'Sweden', iso_code: CountryCode.SE }
]

export const defaultMarketConfig = [
	{
		id: 'gid://shopify/Market/2589098230',
		store: 'EU',
		currency: 'EUR',
		webPresences: [{ defaultLocale: 'en', domain: 'www.auk.com' }],
		countries: [
			'AT',
			'BE',
			'BG',
			'CY',
			'CZ',
			'DE',
			'EE',
			'ES',
			'FI',
			'FR',
			'GR',
			'HR',
			'HU',
			'IE',
			'IT',
			'LT',
			'LU',
			'LV',
			'MT',
			'NL',
			'PL',
			'PT',
			'RO',
			'SI',
			'SK'
		],
		primary: true
	},
	{
		id: 'gid://shopify/Market/2619736310',
		store: 'EU',
		currency: 'DKK',
		webPresences: [{ defaultLocale: 'en', domain: 'www.auk.com' }],
		countries: ['DK'],
		primary: false
	},
	{
		id: 'gid://shopify/Market/2619900150',
		store: 'EU',
		currency: 'CHF',
		webPresences: [{ defaultLocale: 'en', domain: 'www.auk.com' }],
		countries: ['CH'],
		primary: false
	},
	{
		id: 'gid://shopify/Market/2619441398',
		store: 'EU',
		currency: 'GBP',
		webPresences: [{ defaultLocale: 'en', domain: 'www.auk.com' }],
		countries: ['GB'],
		primary: false
	},
	{
		id: 'gid://shopify/Market/58458344',
		store: 'NO',
		currency: 'NOK',
		webPresences: [{ defaultLocale: 'nb', domain: 'www.auk.no' }],
		countries: ['NO'],
		primary: true
	},
	{
		id: 'gid://shopify/Market/37164450072',
		store: 'SE',
		currency: 'SEK',
		webPresences: [{ defaultLocale: 'sv', domain: 'se.auk.com' }],
		countries: ['SE'],
		primary: true
	},
	{
		id: 'gid://shopify/Market/61351395631',
		store: 'US',
		currency: 'USD',
		webPresences: [{ defaultLocale: 'en', domain: 'us.auk.com' }],
		countries: ['US'],
		primary: true
	}
] as API.MarketConfig[]
